import { Component, Input, OnInit, inject } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

export interface POISearchModalResult {
  feature?: GeoJSON.Feature;
  searchQuery?: string;
}

@Component({
    selector: 'app-poi',
    templateUrl: './poi.page.html',
    styleUrls: ['./poi.page.scss'],
    imports: [IonicModule, ReactiveFormsModule, FormsModule, TranslatePipe]
})
export class POIPage implements OnInit {
  private modalController = inject(ModalController);
  private translate = inject(TranslateService);

  @Input()
  public features: GeoJSON.Feature[] = [];
  public filteredFeatures: GeoJSON.Feature[] = null;

  @Input()
  public searchQuery: string;
  public languageCode = 'de';


  constructor() {
    this.languageCode = (this.translate.currentLang() ?? 'de-DE').split('-')[0] ?? 'de';
  }

  ngOnInit(): void {
    if (this.searchQuery) {
      this.search();
    }
  }

  public dismiss(building?: GeoJSON.Feature) {
    this.modalController.dismiss({
      feature: building,
      searchQuery: this.searchQuery
    } satisfies POISearchModalResult);
  }

  public search() {
    const query = this.searchQuery?.trim();

    if (!query) {
      this.filteredFeatures = null;
      return;
    }

    const words = query.toLowerCase().split(' ');
    this.filteredFeatures = this.features.filter((feature) => {
      const normalizedTerm = feature.properties.name[this.languageCode].toLowerCase();
      return words.every((word) => normalizedTerm.indexOf(word) > -1);
    }).slice();
  }
}
